import React, {ReactElement} from "react";

import Icon from "../../icon/Icon";

import translate from "/src/utils/translate";
import {css, generateKeyId} from "/src/utils/utils";

import ArrowLeftIcon from "/src/svg/arrow-left.svg";

import * as styles from "./widget-breadcrumbs.module.scss";

export interface WidgetBreadcrumbsLink {
  label: string;
  href?: string;
}

interface WidgetBreadcrumbsProps {
  links: Array<WidgetBreadcrumbsLink>;
  classes?: string;
}

const WidgetBreadcrumbs = (props: WidgetBreadcrumbsProps): ReactElement => {
  const {links, classes} = props;

  return (
    <nav
      aria-label={translate("Breadcrumbs")}
      className={css(styles.widgetBreadcrumbs, classes!)}
    >
      <Icon
        role="presentation"
        svg={ArrowLeftIcon}
        classes={styles.widgetBreadcrumbs__icon}
      />

      <div>
        {links.map((link, i) => {
          const {label, href} = link;
          const temp: Record<string, string> = {};
          const isLast = i === links.length - 1;

          // if last item set aria-current attr
          if (isLast) {
            temp["aria-current"] = "page";
          }

          const key = generateKeyId(`widget-breadcrumbs-${label}-${i}`);

          return href != null ? (
            <a
              {...temp}
              href={href}
              className={css("p-small", styles.widgetBreadcrumbs__link)}
              key={key}
            >
              {label}
            </a>
          ) : (
            <span
              className={css("p-small", styles.widgetBreadcrumbs__link)}
              key={key}
            >
              {label}
            </span>
          );
        })}
      </div>
    </nav>
  );
};

export default WidgetBreadcrumbs;
